// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"79":"5e593f58","142":"5a66436a","364":"7812c17e","493":"3b20b923","693":"c37ad31a","856":"ac641365","959":"7238f71e"}[chunkId] + ".css";
};